import React, { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';

import { CustomersWithCustomElementsE } from '../../../declarations/enums/common';
import { FooterDataI } from '../../../declarations/interfaces/customer';
import {
  FooterStyled,
  LogoStyled,
  LogoWrapperStyled,
  PoweredByWrapperStyled,
} from './Footer.styled';

type FooterPropsT = {
  data: FooterDataI;
  slugUrl: string;
  isIframe?: boolean;
};

const IlhaDeToqueFooter = React.lazy(
  () => import('../../CustomFooters/IlhaDeToqueFooter/IlhaDeToqueFooter')
);
const SixSensesDouroValleyFooter = React.lazy(
  () => import('../../CustomFooters/SixSensesDouroValleyFooter/SixSensesDouroValleyFooter')
);
const WayajEarthFriendlyTravelFooter = React.lazy(
  () => import('../../CustomFooters/WayajEarthFriendlyTravelFooter/WayajEarthFriendlyTravelFooter')
);
const MuraltoMadridPrincesaFooter = React.lazy(
  () => import('../../CustomFooters/MuraltoMadridPrincesaFooter/MuraltoMadridPrincesaFooter')
);
const BahiaMarBotiqueFooter = React.lazy(
  () => import('../../CustomFooters/BahiaMarBoutiqueFooter/BahiaMarBoutiqueFooter')
);
const MondiLodgeFooter = React.lazy(
  () => import('../../CustomFooters/MondiLodgeFooter/MondiLodgeFooter')
);
const TamarindTreeDominicaFooter = React.lazy(
  () => import('../../CustomFooters/TamarindTreeDominicaFooter/TamarindTreeDominicaFooter')
);
const InterAmericanInstituteFooter = React.lazy(
  () => import('../../CustomFooters/InterAmericanInstituteFooter/InterAmericanInstituteFooter')
);

const CustomFooters = {
  [CustomersWithCustomElementsE.ILHA_DE_TOQUE_ECO_BOTIQUE_HOTEL_SAO_SEBASTIAO]: {
    footer: <IlhaDeToqueFooter />,
  },
  [CustomersWithCustomElementsE.SIX_SENSES_DOURO_VALLEY_SAMODAES]: {
    footer: <SixSensesDouroValleyFooter />,
  },
  [CustomersWithCustomElementsE.WAYAJ_EARTH_FRIENDLY_TRAVEL]: {
    footer: <WayajEarthFriendlyTravelFooter />,
  },
  [CustomersWithCustomElementsE.MURAL_TO]: {
    footer: <MuraltoMadridPrincesaFooter />,
  },
  [CustomersWithCustomElementsE.BAHIA_MAR_BOTIQUE]: {
    footer: <BahiaMarBotiqueFooter />,
  },
  [CustomersWithCustomElementsE.MONDI_LODGE]: {
    footer: <MondiLodgeFooter />,
  },
  [CustomersWithCustomElementsE.TAMARIND_TREE_DOMINICA]: {
    footer: <TamarindTreeDominicaFooter />,
  },
  [CustomersWithCustomElementsE.INTER_AMERICAN_INSTITUTE_FOR_COOPERATION]: {
    footer: <InterAmericanInstituteFooter />,
  },
};

export const Footer: React.FC<FooterPropsT> = ({ data, slugUrl, isIframe }) => {
  const { optionalNavHtml, footerSectionData, cssData } = data;
  const CustomFooter = CustomFooters[slugUrl as keyof typeof CustomFooters]?.footer;

  return (
    <>
      <PoweredByWrapperStyled>
        <LogoWrapperStyled>
          <FormattedMessage id="common.poweredBy" defaultMessage="Powered by" />
          <LogoStyled src={'/images/logo_wayaj.png'} alt="Wayaj logo" />
        </LogoWrapperStyled>
      </PoweredByWrapperStyled>

      {!isIframe &&
        (!!CustomFooter ? (
          <Suspense fallback={null}>{CustomFooter}</Suspense>
        ) : (
          <>
            <FooterStyled>
              {cssData && <style>{cssData}</style>}
              {footerSectionData.split("', '").map((row: string, i: number) => (
                <span
                  key={`footer-${i}`}
                  className="footer-row"
                  dangerouslySetInnerHTML={{ __html: row }}
                />
              ))}
            </FooterStyled>
            {optionalNavHtml && <div dangerouslySetInnerHTML={{ __html: optionalNavHtml }} />}
          </>
        ))}
    </>
  );
};

export default Footer;
